["load", "resize"].forEach((evt) => {
    window.addEventListener(evt, () => {
        moveDropdownMenuIcons();
    });
});

function moveDropdownMenuIcons() {
    const icons = document.querySelectorAll(".js-move-icon");
    if (!icons || icons.length === 0) {
        console.log(new Error("Изображения для перемещния из одного меню в другое не найдены"));
        return;
    }

    if (icons && icons.length > 0) {
        const subCats = document.querySelectorAll(".js-move-icon-end-point");
        const mainLinks = document.querySelectorAll(".js-move-icon-initial-point");

        if (!subCats || !mainLinks) {
            console.log(
                new Error(
                    "Начальная или конечная точка для перемещения изображений меню не найдены",
                ),
            );
            return;
        }

        if (window.mobileMedia) {
            for (let i = 0; i < icons.length; i++) {
                const icon = icons[i];
                if (subCats[i]) subCats[i].prepend(icon);
            }
        } else {
            for (let i = 0; i < icons.length; i++) {
                const icon = icons[i];
                if (mainLinks[i]) mainLinks[i].prepend(icon);
            }
        }
    }
}
